import { api } from '@/services/api';
import type { ILoginRequest, ILoginResponse, ILogoutRequest, IUser } from '@/types/auth';

export const authKeys = {
  all: ['auth'] as const,
  me: ['auth', 'me'] as const,
};

export function login(payload: ILoginRequest): Promise<ILoginResponse> {
  return api.post<ILoginResponse>('/auth/login', payload);
}

export function logout(payload: ILogoutRequest): Promise<void> {
  return api.post('/auth/logout', payload);
}

export function fetchMe(): Promise<IUser> {
  return api.get<IUser>('/auth/me');
}
